import React, { useEffect, useState } from 'react';
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumb from "Components/UI/Breadcrumb";
import PaginatedTable from "Components/Tables/PaginatedTable";
import useTableFilters from 'helpers/hooks/useTableFilters';
import { getBookings } from 'helpers/API Calls/Operations/booking';
import Spinner from 'Components/UI/Spinner';
import convertDateFormat from 'Components/Date/DateFormat';
import { generateQueryParams } from 'helpers/queryParams';
import { getStatusBadge } from '../Bookings/Bookings/status';
import { Link } from 'react-router-dom';
// import ConformationModal from 'Components/Modals/ConformationModal';

const tableHead = [
  { id: 1, name: "#", isSortable: true, key: "invoice_id" },
  { id: 2, name: "Customer", isSortable: true, key: "customer_name" },
  { id: 3, name: "Booking", isSortable: false, key: "booking_name" },
  { id: 4, name: "Amount", isSortable: true, key: "total_amount" },
  { id: 14, name: "Payment Method", isSortable: false, key: "total_amount" },
  { id: 5, name: "Status", isSortable: true, key: "payment_status" },
  { id: 6, name: "Created", isSortable: true, key: "payment_created_at" },
  { id: 7, name: "Updated", isSortable: true, key: "payment_updated_at" },
  { id: 8, name: "Actions", isSortable: false, key: "actions" }
];

function InvoiceListing() {
 const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<any[]>([]);
  const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});
  
  const { filters, updateFilter } = useTableFilters();
  
  const fetchData = async () => {
    setIsLoading(true);
    const response = await getBookings(generateQueryParams(filters));
    if (response.success) {
      setData(response.data.items);
      setPagination(response.data.pagination);
    }
    setIsLoading(false);
  }

  useEffect(() => {
  fetchData();
  }, [filters]);

  // const [clearModal, setClearModal] = useState<boolean>(false);
  // const [selectedItem, setSelectedItem] = useState<any>(null);
    

  // const handleClearClick = (item) => {
  //   setSelectedItem(item);
  //   setClearModal(true);
  // };

  // const handleClearConfirm = async () => {
  //   if (selectedItem) {
  //     const response = await clearBooking(selectedItem?.payments?.[0]?.invoice_id);
  //     if (response.success) {
  //       setClearModal(false);
  //       setSelectedItem(null);
  //       fetchData();
  //     }
  //   }
  // };

  // const onCloseClick = () => {
  //   setClearModal(false);
  //   setSelectedItem(null);
  // };
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb items={[{ label: "Invoices" }]} />
          {isLoading ? <div className="position-relative vh-100"><Spinner/></div>
          :
          <Card>
            <CardBody>
              <PaginatedTable
                tableHead={tableHead}
                pagination={pagination}
                updateFilter={updateFilter}
                filters={filters}
                > 
                {data.length > 0 && data.map((item) => (
                  <tr key={item.id}>
                    <td>{item?.payments?.[0]?.invoice_id}</td>
                    <td>{item?.customer?.name}</td>
                    <td>
                      <Link title="View" to={`/bookings/${item.id}/edit`}>
                        {`B-${item?.id}`} 
                        {/* {item?.booking_status?.status_slug} - 
                        {item?.payments[0].payment_method} */}
                      </Link>
                    </td>
                    <td>{Number(item?.payments?.[0]?.total_amount).toFixed(2)}</td>
                    <td>{item?.payments[0]?.payment_method.toUpperCase()}</td>
                    <td>{getStatusBadge(item?.payments?.[0]?.payment_status_slug || "")}</td>
                    <td>{convertDateFormat(item?.payments?.[0]?.created_at)}</td>
                    <td>{convertDateFormat(item?.payments?.[0]?.updated_at)}</td>
                    <td>
                      <div>
                        <Link className="btn btn-primary btn-sm me-2" title="View" to={`/payments/${item.id}`}>
                          <i className="bx bx-show" />
                        </Link>
                        {/* {Number(item?.payments?.[0]?.total_amount).toFixed(2) !== 
                         Number(item?.payments?.[0]?.paid_amount).toFixed(2) &&
                          <button className="btn btn-info btn-sm" title="Clear Invoice" onClick={() => handleClearClick(item)} >
                            <i className="bx bx-check-double" />
                          </button>    
                        }       */}
                      </div>
                    </td>
                  </tr>))
                }
                {!isLoading && data.length === 0 && <tr className="text-center"><td colSpan={tableHead.length} className="text-danger">No Data Found</td></tr>}
              </PaginatedTable>
            </CardBody>
          </Card>
          }
        </Container>
      </div>
      {/* {clearModal && 
        <ConformationModal
          show={clearModal}
          onConfirmClick={handleClearConfirm}
          onCloseClick={onCloseClick}
          textBefore='clear booking'
          message={`${`B-${selectedItem?.id}`}`}
          textAfter={`with "${selectedItem?.customer?.name}". This will mark all the unpaid amounts as paid or any refunds as refunded. This action cannot be undone`}
        />
      } */}
    </> 
  );
}

export default InvoiceListing;
